import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import Counter from "../Counter/Counter";
import {
  AiFillGithub,
  AiFillInstagram,
  AiOutlineFilePdf
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
            LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I am fluent in classics like
              <i>
                <b className="purple"> C++, Core Java(Basic),Python(Basic) and JavaScript . </b>
              </i>
              <br />
              <br />
              Passionate in MERN STACK DEV and other necessary web technologies.
              <br />
              <br />
              I am actively seeking for full-time roles in
              <i>
                <b className="purple"> SDE/MERN STACK DEV/Other Web Technologies /Open for other IT roles</b> also. 
              </i>
              
               <br></br>
               <br></br>
               Here is my  <Button variant="Light" href="https://drive.google.com/file/d/1f4xUthJufqWTSqYdN15ZMgEs7B2Ni0Bc/view?usp=sharing"  style={{ backgroundColor: '#c770f0' }}>Resume <AiOutlineFilePdf/> </Button>{' '}
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Rohankumarmenu"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://x.com/RohanKu01725348?t=_MeywUU3u4EuGUggTR1Pxg&s=09"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <BsTwitterX/>
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/rohan-kr/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://instagram.com/rohan_sah._?igshid=OGQ5ZDc2ODk2ZA=="
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
        <Row>
          <Counter/>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
